<div class="container">
  <div class="text-center">
    <mat-icon class="info-icon">info</mat-icon>
    <p>
      <br />
      <b> No Data Available.</b> <br />
      {{ infoMessage }}
    </p>
  </div>
</div>
